import { Label } from "@/core/components/ui/label";
import { Input } from "@/core/components/ui/input";
import useTypedTranslation from "@/core/hooks/use-typed-translation";
import { MAX_REPORTING_RANGE_DAYS } from "@/features/reporting/api/dto";

export interface ReportingDateRangeValue {
  from: string;
  to: string;
}

/** Plage inclusive `from` / `to` (max 400 jours, guide §7.3). */
export function ReportingDateRange({
  value,
  onChange,
}: {
  value: ReportingDateRangeValue;
  onChange: (next: ReportingDateRangeValue) => void;
}) {
  const { t } = useTypedTranslation();

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="space-y-1.5">
        <Label htmlFor="reporting-from">{t("dashboard.range.from")}</Label>
        <Input
          id="reporting-from"
          type="date"
          className="notranslate"
          value={value.from}
          placeholder={t("dashboard.range.fromPlaceholder")}
          onChange={(e) => onChange({ ...value, from: e.target.value })}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="reporting-to">{t("dashboard.range.to")}</Label>
        <Input
          id="reporting-to"
          type="date"
          className="notranslate"
          value={value.to}
          placeholder={t("dashboard.range.toPlaceholder")}
          onChange={(e) => onChange({ ...value, to: e.target.value })}
        />
      </div>
      <p className="text-xs text-muted-foreground">
        {t("dashboard.range.maxDays", { max: MAX_REPORTING_RANGE_DAYS })}
      </p>
    </div>
  );
}
